import React, { useState } from 'react';
import MultiUploader from '../MultiUploader';
import { ICONS } from './linkIcons';
import RegisteredIcon from '../../RegisteredIcon';

export default function LinkForm({ initialData = {}, onSave, onCancel, saving, submitLabel = 'Save Link' }) {
    const [url, setUrl] = useState(initialData.url || '');
    const [title, setTitle] = useState(initialData.title || '');
    const [description, setDescription] = useState(initialData.description || '');
    const [icon, setIcon] = useState(initialData.icon || '');
    const [imageId, setImageId] = useState(null);

    function handleSubmit(e) {
        e.preventDefault();
        const payload = { url, title, description, icon };
        if (imageId !== null) payload.imageId = imageId;
        onSave(payload);
    }

    return (
        <form onSubmit={handleSubmit} className="ltm-form">
            <div className="group">
                <label htmlFor="ltm-url">URL</label>
                <input
                    id="ltm-url"
                    type="text"
                    value={url}
                    onChange={e => setUrl(e.target.value)}
                    placeholder="https://example.com"
                    required
                />
            </div>
            <div className="group">
                <label htmlFor="ltm-title">Title</label>
                <input
                    id="ltm-title"
                    type="text"
                    value={title}
                    onChange={e => setTitle(e.target.value)}
                    placeholder="My Link"
                />
            </div>
            <div className="group">
                <label htmlFor="ltm-description">Description</label>
                <input
                    id="ltm-description"
                    type="text"
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                    placeholder="What is this link?"
                />
            </div>
            <div className="group">
                <label htmlFor="ltm-icon">Icon</label>
                <select id="ltm-icon" value={icon} onChange={e => setIcon(e.target.value)}>
                    {ICONS.map(ic => (
                        <option key={ic.value} value={ic.value}>{ic.text}</option>
                    ))}
                </select>
                {icon && <p className="ltm-icon-preview"><RegisteredIcon value={icon} /> Preview</p>}
                <p className="help">Want an icon not listed? <a href="/account/help?category=links">Request it!</a></p>
            </div>
            <div className="group">
                {initialData.image?.cdnPath ? (
                    <>
                        <label>Current Image</label>
                        <p><img src={initialData.image.cdnPath} alt={initialData.title} style={{ maxWidth: 80 }} /></p>
                        <label>Replace Image</label>
                    </>
                ) : (
                    <label>Custom Image</label>
                )}
                <MultiUploader
                    maxFiles={1}
                    accept="image/jpeg,image/png,image/webp"
                    onUploadSuccess={files => {
                        const id = files[0]?.id;
                        if (id) setImageId(id);
                    }}
                />
            </div>
            <div className="ltm-form-actions">
                <button type="submit" className="button primary" disabled={saving || !url.trim()}>
                    {saving ? 'Saving…' : submitLabel}
                </button>
                {onCancel && (
                    <button type="button" className="button secondary" onClick={onCancel} disabled={saving}>
                        Cancel
                    </button>
                )}
            </div>
        </form>
    );
}
